import { Box } from '@chakra-ui/react';

export const getTooltipLabel = (
  option: string,
  kind?: string
): React.ReactNode => {
  const Bold = ({ children }: { children: React.ReactNode }) => (
    <Box as="span" fontWeight="bold" color="#413B74">
      {children}
    </Box>
  );

  const labels = {
    internal: <Bold>Internal job board</Bold>,
    external: <Bold>External job boards</Bold>,
    career: <Bold>Kula career page</Bold>,
  };

  const listings = {
    internal: <>Listed in the {labels.internal}.</>,
    external: (
      <>
        Listed in {labels.external}, and {labels.career}.
      </>
    ),
    both: (
      <>
        Listed in {labels.external}, {labels.career} and the {labels.internal}.
      </>
    ),
  };

  const actions: Record<string, string> = {
    apply: 'apply',
    refer: 'refer',
    both: 'refer and apply',
  };

  const makeLabel = (listing: React.ReactNode, action?: string) => (
    <Box as="span">
      {listing}
      {action &&
        ` This job allows employees to ${action} via the internal job board.`}
    </Box>
  );

  const normalizedKind =
    kind === 'internal' || kind === 'external' ? kind : 'internal_and_external';

  const getLabelFor = (option: string, kind: string) => {
    switch (kind) {
      case 'internal_and_external':
        return makeLabel(listings.both, actions[option]);
      case 'internal':
        return makeLabel(listings.internal, actions[option]);
      case 'external':
        return <Box as="span">{listings.external}</Box>;
      default:
        return null;
    }
  };

  return getLabelFor(option, normalizedKind);
};
